import { useDrawStore } from 'hooks/stores/useDrawStore';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

interface INudges {
  type: string;
  lines: any[];
}
export const Nudges = observer(({ type, lines }: INudges) => {
  const { treesPlantedCount, winnersLastWeek } = useDrawStore();

  const [percentageChanceOfWinning, setPercentageChanceOfWinning] =
    useState<number>();

  useEffect(() => {
    let chanceOfWinning;
    // According to Andrew's, these are the ‘odds to win any prize’ based on how many entries are selected in a single draw:
    switch (lines?.length) {
      case 1:
        chanceOfWinning = 34;
        break;
      case 2:
        chanceOfWinning = 57;
        break;
      case 3:
        chanceOfWinning = 71;
        break;
      case 4:
        chanceOfWinning = 81;
    }
    setPercentageChanceOfWinning(chanceOfWinning);
  }, [lines?.length]);

  if (!winnersLastWeek && !treesPlantedCount) {
    return null;
  }

  const getNudge = (emoji: string, text: string) => (
    <>
      <p className="emoji medium noMargin">{emoji}</p>
      <p className="xsmall bold">{text}</p>
    </>
  );

  return (
    <div className="nudges grid">
      <div className="nudge grid">
        {type === 'winners' &&
          getNudge('🎉', `${winnersLastWeek} wins last week`)}
        {type === 'trees' && getNudge('🌳', '1 draw = 1 tree')}
      </div>

      <div className="nudge grid nowrap">
        {type === 'winners' &&
          getNudge('🥳', `${percentageChanceOfWinning}% chance to win`)}
        {type === 'trees' &&
          getNudge('🌲', `${treesPlantedCount} trees planted`)}
      </div>

      <style jsx>
        {`
          .nudges {
            width: 100%;
            grid-template-columns: 1fr 1fr;
            grid-gap: 0.75em;
          }
          .nudge {
            align-items: center;
            grid-template-columns: min-content auto;
            grid-gap: 0.5em;
          }

          @media (max-width: 360px) {
            :global(.nudge p.xsmall) {
              font-size: 0.9em;
            }
          }

          @media (max-width: 350px) {
            :global(.nudge p.xsmall) {
              font-size: 0.85em;
            }
          }
        `}
      </style>
    </div>
  );
});
